import React from "react";
import { s3baseUri } from "../../../../config/config";
import { useMediaQuery } from "@mui/material";
import { Carousel } from "react-bootstrap";
import { Clock, Calendar, Ear } from "lucide-react";
import { handle_get_time_ago } from "../../../../utils/Constant";
import moment from "moment";
import {
  arrow,
  calender,
  calenderBack,
  clock,
  clockBack,
  play,
} from "../../../../assets";
import { useParams } from "react-router-dom";

export default function BlogSilder({ slider_blogs, handleDetails }) {
  const isMobile = useMediaQuery("(max-width:600px)", { noSsr: true });
  const { feature_slug } = useParams();

  return (
    <>
      <Carousel
        // interval={3000}
        interval={null}
        pause={false}
        controls={false}
        indicators={slider_blogs?.length > 1}
        className="custom-blog-carousel"
      >
        {slider_blogs?.map((blog, index) => (
          <Carousel.Item key={index}>
            <div className="p-1 carousel-item-container">
              {/* Left Side - Text */}
              <div className="blog-card p-3 align-items-center w-100">
                <div className="row">
                  <div className="col-md-6 col-lg-7 col-xl-8 ps-lg-0">
                    <div className="heading-h3 content-div">
                      <div className="blog-chip-wrapper">
                        {blog?.category?.slice(0, 3).map((category, idx) => (
                          <div className="blog-chip">{category.title}</div>
                        ))}
                      </div>
                      <h2 className={isMobile ? "" : "line-clamp-1"}>
                        {blog?.title}
                      </h2>
                      <p
                        className={
                          isMobile ? "text-gray" : "text-gray line-clamp-1"
                        }
                        style={{ flex: 1 }}
                      >
                        {blog?.short_description?.length > 300
                          ? blog?.short_description.slice(0, 300) + "..."
                          : blog?.short_description}
                      </p>
                      <div className="podcast-icons">
                        <div className="">
                          <img src={clockBack} className="img-fluid" />
                          <span>{handle_get_time_ago(blog?.createdAt)}</span>
                        </div>
                        <div className="ps-2 ps-lg-4">
                          <img src={calenderBack} className="img-fluid" />

                          <span>
                            {moment(blog?.createdAt).format("DD MMM, YYYY")}
                          </span>
                        </div>
                        {/* <div>
                        <Ear className="icon-background" height={28} width={28}
                        />

                        <span>
                          Listen
                        </span>
                      </div> */}
                      </div>
                      <div className="text-center text-lg-start">
                        <button
                          className="small-button-cotain-view-all"
                          onClick={() => handleDetails(blog)}
                        >
                          {false ? (
                            <>
                              <img
                                src={play}
                                alt=""
                                className="img-fluid me-2"
                                height={18}
                                width={18}
                              />
                              View Podcast
                            </>
                          ) : (
                            <>
                              Read Article
                              <img
                                src={arrow}
                                alt=""
                                className="img-fluid ms-3"
                                height={18}
                                width={18}
                              />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div
                    className="col-md-6 col-lg-5 col-xl-4 pe-lg-0"
                    style={{
                      marginTop: isMobile ? "15px" : "",
                    }}
                  >
                    <img
                      className="d-block card-img w-100"
                      style={{ aspectRatio: "1/1" }}
                      src={s3baseUri + blog?.image[0]?.thumbnail_2}
                      alt={blog?.name}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
}
